import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import ApprovalInformation from "../InfoForConfirmation";

const EditCheckForm = (props) => {
    const {
        handleSubmit,
        handleEditCheckInputChange,
        status,
        confirm_status_info,
        onRecommendationChange,
        handleLetterWarningChange,
        view,
        fullname,
        BackToTable,
        extensionPeriod,
        extensionComment,
        comment,
        effectiveDate,
        employment_id,
        designations,
        department,
        level,
        letterWarning,
        score,
        achievement,
        warningDate,
        recommendation,
        date,
        check_person,
        verify_person,
        sub_level_options,
        career_level_id,
        selected_sub_level,
        handleSelectedSubLevel,
        recommend_level,
        status_info,
        confirmPerson,
        edit,
        checkListData,
    } = props;

    const filter_sub_level = sub_level_options.filter(
        (v) => v.career_level_id == career_level_id
    );
    const selected_level = sub_level_options.filter(
        (v) => v.career_sub_level_id == recommend_level
    );

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div
                    style={{
                        padding: 10,
                        justifyContent: "center",
                        boxShadow: "5px 5px 5px lightgrey",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <h3 style={{ fontWeight: "bold" }}>Confirmation Assessment Form</h3>
                    </div>
                    <div
                        className="w-100"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: 10,
                            paddingTop: 20,
                        }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-4 col-md-4 col-sm-4">Employee Name</div>
                            <div className="col-lg-2-col-md-2 col-sm-2">:</div>
                            <div className="col-lg-6 col-md-6 col-sm-6">{fullname}</div>
                        </div>
                    </div>

                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-4 col-md-4 col-sm-4">Employee ID</div>
                            <div className="col-lg-2-col-md-2 col-sm-2">:</div>
                            <div className="col-lg-6 col-md-6 col-sm-6">{employment_id}</div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-4 col-md-4 col-sm-4">Designation</div>
                            <div className="col-lg-2-col-md-2 col-sm-2">:</div>
                            <div className="col-lg-6 col-md-6 col-sm-6">{designations}</div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-4 col-md-4 col-sm-4">Department</div>
                            <div className="col-lg-2-col-md-2 col-sm-2">:</div>
                            <div className="col-lg-6 col-md-6 col-sm-6">{department}</div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-4 col-md-4 col-sm-4">Level</div>
                            <div className="col-lg-2-col-md-2 col-sm-2">:</div>
                            <div className="col-lg-6 col-md-6 col-sm-6">{level}</div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">Date</div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <input
                                    type="text"
                                    placeholder=""
                                    required
                                    name="date"
                                    value={moment(new Date()).format("YYYY-MM-DD")}
                                    onChange={handleEditCheckInputChange}
                                    style={{ height: 40, width: 160 }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                Performance Score
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <input
                                    type="number"
                                    placeholder=""
                                    required
                                    name="score"
                                    value={score}
                                    onChange={handleEditCheckInputChange}
                                    style={{ height: 40 }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                Target Achievement
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <input
                                    type="text"
                                    placeholder=""
                                    required
                                    name="achievement"
                                    value={achievement}
                                    onChange={handleEditCheckInputChange}
                                    style={{ height: 40 }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">Letter Warning</div>

                            <div
                                className="col-lg-6 col-md-6 col-sm-6"
                                style={{ alignItems: "center", display: "flex" }}
                            >
                                <input
                                    type="radio"
                                    placeholder=""
                                    value="letterWarning"
                                    checked={letterWarning}
                                    onChange={handleLetterWarningChange}
                                    style={{ height: 40, marginRight: 10 }}
                                    disabled
                                />
                                {letterWarning == true ? "Yes" : "NO"}
                            </div>
                        </div>
                    </div>
                    {letterWarning == true ? (
                        <div
                            className="w-100"
                            style={{ display: "flex", justifyContent: "center", padding: 10 }}
                        >
                            <div
                                className="col-lg-6 col-md-10 col-sm-12"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                }}
                            >
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    Letter Warning Date
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <input
                                        type={view ? "text" : "date"}
                                        placeholder=""
                                        name="letterWarningDate"
                                        value={moment(warningDate).format("YYYY-MM-DD")}
                                        onChange={handleEditCheckInputChange}
                                        style={{ height: 40, width: 160 }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">Recommendation</div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        paddingTop: 10,
                                    }}
                                >
                                    <input
                                        type="radio"
                                        placeholder=""
                                        value="Confirmation"
                                        checked={
                                            recommendation === "Confirmation" ||
                                            recommendation === null
                                        }
                                        onChange={onRecommendationChange}
                                        style={{ height: 40, marginRight: 10 }}
                                        required
                                    />
                                    Confirmation
                                </div>
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        paddingTop: 10,
                                    }}
                                >
                                    <input
                                        type="radio"
                                        placeholder=""
                                        value="Extensions"
                                        checked={recommendation === "Extensions"}
                                        onChange={onRecommendationChange}
                                        style={{ height: 40, marginRight: 10 }}
                                        required
                                    />
                                    Extensions
                                </div>
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        paddingTop: 10,
                                    }}
                                >
                                    <input
                                        type="radio"
                                        placeholder=""
                                        value="Terminations"
                                        checked={recommendation === "Terminations"}
                                        onChange={onRecommendationChange}
                                        style={{ height: 40, marginRight: 10 }}
                                        required
                                    />
                                    Terminations
                                </div>
                            </div>
                        </div>
                    </div>
                    {recommendation === "Extensions" ? (
                        <div
                            className="w-100"
                            style={{ display: "flex", justifyContent: "center", padding: 10 }}
                        >
                            <div
                                className="col-lg-6 col-md-10 col-sm-12"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                }}
                            >
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    Extension Period
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <input
                                        type="text"
                                        placeholder=""
                                        name="extensionPeriod"
                                        value={extensionPeriod}
                                        onChange={handleEditCheckInputChange}
                                        style={{ height: 40 }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {recommendation === "Extensions" ? (
                        <div
                            className="w-100"
                            style={{ display: "flex", justifyContent: "center", padding: 10 }}
                        >
                            <div
                                className="col-lg-6 col-md-10 col-sm-12"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                }}
                            >
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    Extension Comment
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <input
                                        type="text"
                                        placeholder=""
                                        name="extensionComment"
                                        value={extensionComment}
                                        onChange={handleEditCheckInputChange}
                                        style={{ height: 40 }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                Recommended Level
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div style={{ width: 175 }}>
                                    <Select
                                        required
                                        options={filter_sub_level}
                                        value={selected_level}
                                        onChange={handleSelectedSubLevel}
                                        className="react-select-container checkValidate"
                                        classNamePrefix="react-select"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="w-100"
                        style={{ display: "flex", justifyContent: "center", padding: 10 }}
                    >
                        <div
                            className="col-lg-6 col-md-10 col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                            }}
                        >
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                Comment on Overall Performance
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <textarea
                                    type="text"
                                    placeholder=""
                                    required
                                    name="comment"
                                    value={comment}
                                    onChange={handleEditCheckInputChange}
                                    rows={4}
                                    cols={50}
                                />
                            </div>
                        </div>
                    </div>

                    {status >= 2 && (view || edit) ? (
                        <div
                            className="w-100"
                            style={{ display: "flex", justifyContent: "center", padding: 10 }}
                        >
                            <div
                                className="col-lg-6 col-md-10 col-sm-12"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                }}
                            >
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    Confirmation Effective Date
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <input
                                        type={view ? "text" : "date"}
                                        placeholder=""
                                        required={status == 2 && recommendation == "Confirmation"}
                                        name="effectiveDate"
                                        value={
                                            effectiveDate
                                                ? moment(effectiveDate).format("YYYY-MM-DD")
                                                : null
                                        }
                                        onChange={handleEditCheckInputChange}
                                        style={{ height: 40, width: 160 }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    {check_person == props.user_id && status == 0 ? (
                        <div
                            className="w-100 mx-2"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 20,
                            }}
                        >
                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ borderRadius: 10, width: 120 }}
                            >
                                Check{" "}
                            </button>
                        </div>
                    ) : confirmPerson == props.user_id && status == 1 ? (
                        <div
                            className="w-100 mx-2"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 20,
                            }}
                        >
                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ borderRadius: 10, width: 120 }}
                            >
                                Confirm{" "}
                            </button>{" "}
                        </div>
                    ) : checkListData != undefined &&
                        checkListData.filter((c) => c.isHR == "HR").length > 0 &&
                        checkListData
                            .filter((c) => c.isHR == "HR")
                            .map((v) => ({ ...v, select: true })) &&
                        status == 2 ? (
                        <div
                            className="w-100 mx-2"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 20,
                            }}
                        >
                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ borderRadius: 10, width: 120 }}
                            >
                                Verify{" "}
                            </button>{" "}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </form>
            {view ? (
                <div className="row approval-main">
                    {!Array.isArray(confirm_status_info) ? (
                        <div className="margin-top-20">
                            <ApprovalInformation status={confirm_status_info} />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            ) : null}
        </>
    );
};

export default EditCheckForm;

// < div className = 'w-100 mx-2' style = {{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
//     <button type='submit' className='btn btn-primary' style={{ borderRadius: 10, width: 120 }}>{props.user_id == 17 ? 'Verify' : 'Submit'} </button>

//                     </div >
